// extracted by mini-css-extract-plugin
module.exports = {"page-content-root":"page-content-root-2n7ZF","page-content":"page-content-XxyQi","footer":"footer-2E5Pl","page-loading":"page-loading-24x8z"};